import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "warning"]
  static values = { deadline: String }

  connect() {
    this.check()
  }

  check() {
    this.warningTarget.hidden = !(this.inputTarget.value > this.deadlineValue)
  }
}
